import { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Image,
  Badge,
} from 'react-bootstrap';
import { FaStar } from 'react-icons/fa';

const bookingData = [
  {
    id: 1,
    serviceName: 'Full Body Waxing',
    package: 'Package',
    rating: 4.83,
    bookings: '4.4M',
    price: 1629,
    image: 'https://naturalspapune.com/wp-content/uploads/2023/07/Untitled-design-11-1024x768.png',
    status: 'Complete',
    date: '2025-07-10',
  },
  {
    id: 2,
    serviceName: 'Hair Spa',
    package: 'Premium Care',
    rating: 4.72,
    bookings: '2.1M',
    price: 899,
    image: 'https://naturalspapune.com/wp-content/uploads/2023/07/Untitled-design-11-1024x768.png',
    status: 'Complete',
    date: '2025-06-28',
  },
];

export default function OrderList() {
    
  return (
    <Container className="py-4">
      {bookingData.map((booking) => (
        <Card
          key={booking.id}
          className="mb-4 border-0 shadow-sm hover-shadow transition"
          style={{ borderRadius: '16px' }}
        >
          <Row className="g-0">
            {/* Left: Image */}
            <Col md={4} xs={12}>
              <Image
                src={booking.image}
                alt={booking.serviceName}
                fluid
                style={{
                  height: '100%',
                  objectFit: 'cover',
                  borderTopLeftRadius: '16px',
                  borderBottomLeftRadius: '16px',
                }}
              />
            </Col>

            {/* Right: Details */}
            <Col md={8} xs={12}>
              <Card.Body className="p-4 d-flex flex-column justify-content-between h-100">
                <div>
                  <h5 className="fw-bold mb-1">{booking.serviceName}</h5>
                  <p className="text-muted small mb-2">{booking.package}</p>

                  <div className="d-flex align-items-center mb-2">
                    <Badge bg="success" className="me-2">
                      <FaStar className="me-1" /> {booking.rating}
                    </Badge>
                    <small className="text-muted">
                      ({booking.bookings} bookings)
                    </small>
                  </div>

                  <h6 className="text-danger fw-semibold">
                    ₹{booking.price.toLocaleString('en-IN')}.00
                  </h6>
                </div>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <Badge bg="info" className="px-3 py-1 rounded-pill">
                    {booking.status}
                  </Badge>
                  <small className="text-muted">
                    Booked on {new Date(booking.date).toLocaleDateString()}
                  </small>
                </div>

                <Button variant="primary" className="mt-4 w-100">
                  Re-book
                </Button>
              </Card.Body>
            </Col>
          </Row>
        </Card>
      ))}
    </Container>
  )
}
